import { http } from "./Config";
import settings from "@/settings";
export default {
  
  list: (idPedido) => {
    return http.get(
        settings.usuarioAutenticado.GET_ITEM +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE +
        "&pedido=" +
        idPedido
    );
  },

  save: (item) => {
    return http.post(
        settings.usuarioAutenticado.SET_ITEM +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE,
      item
    );
  },

};
